<div class="header">
  <i [lvIcon]="icon" class="test-icon"></i>
  <strong class="label-text">{{ label }}</strong>
  <span class="failure-text" [innerHTML]="failure"></span>
  <i [lvIcon]="stateIcon()" class="state-icon"></i>
</div>
<div class="test-items">
  <ng-content></ng-content>
</div>
